<template>
  <div class="main-staff1">
    <el-container class="auth-container">
      <div class="staff-title">
        <div class="title-name">员工部门</div>
        <el-aside class="auth-aside">
          <el-tree
            style="height: 100%"
            :data="listData"
            @node-click="nodeClick"
            @check="handleCheckChange"
            node-key="departmentId"
            :default-expanded-keys="defaultShowNodes"
            :default-checked-keys="defaultCheckedKeys"
            :expand-on-click-node="false"
            :current-node-key="currentNodeKey"
            ref="authTree"
            :highlight-current="true"
            :check-on-click-node="true"
            :props="defaultProps"
            class="tree filter-tree"
          >
            <div class="comp-tr-node" slot-scope="{ node, data }">
              <template>
                <div class="comp-tr-node--name">
                  {{ node.label }}
                </div>
              </template>
            </div>
          </el-tree>
        </el-aside>
      </div>

      <div style="border-right: 1px solid #ebeef5"></div>
      <el-main class="auth-main">
        <div class="tip-wrap">
          <div class="num-wrap">
            启用账号数 {{ pointRespon.licenseOpen + "/" + pointRespon.point }}
          </div>
          <div class="time-out-wrap" v-if="pointRespon.mark == 2">
            {{
              "服务将于" +
                pointRespon.expiredTime +
                "到期，请联系客莱宝平台人员续期"
            }}
          </div>
        </div>
        <el-form
          :inline="true"
          class="login-form"
          status-icon
          ref="loginForm"
          label-width="0"
          style="margin-bottom: -10px"
        >
          <el-form-item>
            <el-select
              v-model="formInline.status"
              clearable
              placeholder="启用状态"
              size="mini"
              @change="selectStatus"
              style="width: 140px"
            >
              <el-option
                v-for="item in enableOptions"
                :key="item.enbaleStatus"
                :label="item.label"
                :value="item.enbaleStatus"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              size="mini"
              v-model="queryDepart"
              placeholder="部门"
              @blur="onInputBlurDepart"
              @clear="onInputBlurNameMobile"
              clearable
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              size="mini"
              v-model="formInline.queryStaff"
              placeholder="输入姓名、手机号搜索"
              @blur="onInputBlurNameMobile"
              @clear="onInputBlurNameMobile"
              clearable
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="formInline.bindStatus"
              clearable
              placeholder="绑定状态"
              size="mini"
              @change="selectBindStatus"
              style="width: 140px"
            >
              <el-option
                v-for="item in bindOptions"
                :key="item.bindStatus"
                :label="item.label"
                :value="item.bindStatus"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="mini"
              @click="synchronizesContact"
              :loading="isSynchronizes"
              >{{ isSynchronizes ? "正在同步..." : "同步通讯录" }}</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-checkbox
              @change="jobStatusChange"
              :true-label="0"
              :false-label="1"
              v-model="formInline.jobStatus"
              >显示离职员工</el-checkbox
            >
          </el-form-item>
        </el-form>
        <tableWrap>
          <template #table>
            <el-table
              size="medium"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              ref="singleTable"
              height="100%"
              :highlight-current-row="true"
              :data="staffData"
              style="width: 100%; font-size: 13px"
            >
              <el-table-column
                prop="name"
                label="员工"
                min-width="120"
                show-overflow-tooltip
                align="left"
              ></el-table-column>
              <el-table-column
                prop="mobile"
                label="手机号"
                min-width="130"
                align="left"
              ></el-table-column>
              <el-table-column
                prop="departmentName"
                label="所属部门"
                min-width="280"
                align="left"
              ></el-table-column>
              <el-table-column
                prop="adminDepart"
                label="管理部门"
                min-width="280"
                align="left"
              >
              </el-table-column>
              <el-table-column
                prop="role"
                label="角色"
                min-width="170"
                align="center"
              >
                <template slot-scope="scope">
                  <!-- <span v-if="scope.row.staffRole == 1" style="color: rgb(8, 168, 231)">超级管理员</span>
                    <span v-else>普通职工</span> -->
                  <span
                    v-for="item in scope.row.staffRoleList"
                    :key="item.roleId"
                  >
                    <el-link
                      type="primary"
                      :underline="false"
                      style="margin-right: 5px; font-size: 13px"
                      >{{ item.roleName }}</el-link
                    >
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="userId"
                label="企微账号"
                min-width="180px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="bindStatus"
                fixed="right"
                label="绑定状态"
                min-width="150"
                align="center"
              >
                <template slot="header" slot-scope="scope">
                  <div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="与宏脉院务系统职员的绑定情况"
                      placement="top-start"
                    >
                      <div>
                        绑定状态<i class="el-icon-question icon-style"></i>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
                <template slot-scope="scope">
                  <el-tag
                    type="success"
                    size="medium"
                    v-if="scope.row.bindStatus"
                    :style="kbdjb ? 'cursor: pointer;' : ''"
                    @click="handleBind(scope.row)"
                    ><i class="staff-icon"></i> 已绑定
                    <i
                      v-if="kbdjb"
                      class="el-icon-arrow-right"
                      style="position: relative; left: 3px; top: 1px"
                    ></i
                  ></el-tag>
                  <el-tag
                    type="warning"
                    size="medium"
                    v-else
                    :style="kbdjb ? 'cursor: pointer;' : ''"
                    @click="handleBind(scope.row)"
                  >
                    未绑定
                    <i
                      v-if="kbdjb"
                      class="el-icon-arrow-right"
                      style="position: relative; left: 3px; top: 1px"
                    ></i
                  ></el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="启用状态"
                fixed="right"
                min-width="96px"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0">{{ "已停用" }}</span>
                  <span v-if="scope.row.status == 1">{{ "已启用" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                fixed="right"
                min-width="68px"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.status == 0"
                    class="enable"
                    @click="enableAccount(scope.row.userId)"
                    >{{ "启用" }}</span
                  >
                  <span
                    v-if="scope.row.status == 1"
                    class="unenable"
                    @click="disableAccount(scope.row)"
                    >{{ "停用" }}</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template #pagination>
            <Pagination
              v-bind:childMsg="pageparm"
              :pageSizes="pageSizes"
              @callBack="callBack"
            ></Pagination>
          </template>
        </tableWrap>
      </el-main>
      <el-dialog
        title="员工绑定"
        :visible.sync="dialogVisibleBind"
        width="65%"
        class="dialog-comster"
        :before-close="handleClose"
      >
        <div style="margin-bottom: 5px">选取宏脉院务系统的职员进行绑定。</div>
        <div class="staff1-search">
          <el-input
            size="small"
            style="width: 22%; margin-right: 10px"
            v-model="searchObj.empCodeOrName"
            placeholder="院务系统职员姓名、职员编号"
            @blur="searchFn"
            @clear="searchFn"
            clearable
          >
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div>
          <el-table
            size="small "
            ref="multipleTables"
            :data="informationList"
            @current-change="handleSelectionChange"
            :height="tableHeight - 115"
            :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
            :row-style="rowClass"
            style="width: 100%"
          >
            <el-table-column label="操作" width="70">
              <template slot-scope="scope">
                <el-radio
                  v-model="tableChecked"
                  :label="scope.row.id"
                  :disabled="scope.row.customState == 1"
                ></el-radio>
                <!-- 单选的也可以用单选框,这样效果更明显,选择之后不能取消 -->
              </template>
            </el-table-column>
            <!-- <el-table-column type="selection" width="50"></el-table-column> -->
            <el-table-column
              prop="earName"
              label="机构名称"
              min-width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="empName"
              label="职员名称"
              min-width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="empCode"
              label="职员编号"
              min-width="100px"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dptName"
              label="职员部门"
              min-width="120"
              align="center"
            >
              <template slot="header" slot-scope="scope">
                <el-dropdown trigger="click" @command="searchFn">
                  <div style="cursor: pointer">
                    {{ bumenName }}
                    <i
                      class="el-icon-caret-bottom"
                      style="
                        position: relative;
                        font-size: 14px;
                        left: -1px;
                        top: 1px;
                      "
                    ></i>
                  </div>
                  <el-dropdown-menu
                    slot="dropdown"
                    style="
                      width: 200px;
                      height: 207px;
                      overflow-y: scroll;
                      left: 677px !important;
                    "
                  >
                    <el-dropdown-item
                      v-for="(item, index) in departmentList"
                      :command="item.id"
                      :key="index"
                      >{{ item.dptName }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>

            <el-table-column
              prop="customState"
              style="display: inline-block; margin: 0 20px"
              label="绑/解操作"
              min-width="120"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.customState != 1">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="hanldeBingFn(scope.row, scope.$index)"
                    v-if="
                      currentSelectItem
                        ? currentSelectItem.id == scope.row.id
                        : false
                    "
                    >绑定</el-button
                  >
                  <span
                    style="
                      color: #c9cdd4;
                      padding: 7px 15px;
                      display: inline-block;
                    "
                    v-else
                    >绑定</span
                  >
                </div>
                <span
                  v-else
                  style="cursor: pointer; color: #040930"
                  @click="hanldeDelete(scope.row, scope.$index)"
                  >解 绑</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="qwAccount"
              label="企业微信账号"
              min-width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="departmentName"
              label="部门"
              min-width="120px"
              align="center"
            ></el-table-column>
          </el-table>
          <Pagination
            v-bind:childMsg="diaPageParm"
            :pageSizes="pageSizes"
            @callBack="diaCallBack"
          ></Pagination>
        </div>
      </el-dialog>
    </el-container>
    <!-- 添加人员树 -->
    <!-- <StaffTree title='选择成员' :dialogVisibleTree='staffTreeShow' :selectNum='1' :toBeReplaced='toBeReplaced' :currentSelectMember='currentSelectMember' @closeTree='closeTree' :mark='1'  @clickSubmitTree='clickSubmitTree' oldSelectTitle='待停用权限的成员' currentSelectTitle='待接收权限的成员'></StaffTree> -->
    <StaffTreeTwo
      title="选择成员"
      :dialogVisibleTree="staffTreeShow"
      :selectNum="1"
      :toBeReplaced="toBeReplaced"
      :currentSelectMember="currentSelectMember"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
      oldSelectTitle="待停用权限的成员"
      currentSelectTitle="待接收权限的成员"
    ></StaffTreeTwo>
  </div>
</template>
<script>
import tableWrap from "@/components/tabelWrap.vue";
// import StaffTree from "@/components/staffTree.vue"
import StaffTreeTwo from "@/components/staffTree/staffTreeTwo.vue";
import {
  getDepartmentList,
  getDepartmentStaff,
  setStatffStatus,
  setStaffAppStatus,
  getEmpBind,
  getEmpDepart,
  saveEmpBind,
  deleteEmpBind,
  syncWeStaffInformal,
  getLicensePoint,
  userEnable,
  isTransfer,
  disEnable,
} from "../../api/staff/staff.js";

export default {
  components: {
    tableWrap,
    // StaffTree,
    StaffTreeTwo,
  },
  data() {
    return {
      currentSelectMember: [],
      toBeReplaced: [], // 待更换的成员
      staffTreeShow: false,
      disablePrams: {
        corpId: "", //企业id
        handoverUserId: "", //转移员工userId
        takeoverUserId: "", //接收员工userId
      },
      isSynchronizes: false, // 同步通讯录加载中标识符
      kbdjb: true, // 可绑定解绑与否
      defaultShowNodes: [1], //树形默认展开节点编号
      defaultCheckedKeys: [1],
      currentNodeKey: "",
      tableHeight: 500, //表格距离浏览器底部距离，初始为200
      listData: [],
      staffData: [],
      // loading: false,
      defaultProps: {
        //修改树形结构的默认属性名称
        id: "departmentId",
        children: "children",
        label: "departmentName",
      },
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      diaPageParm: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      formInline: {
        currentPage: 1,
        pageSize: 20,
        bindStatus: "",
        queryStaff: "", //搜索框姓名/手机查询条件
        status: "", //  账号启用状态 0：停用  1：启用
        /** 账号启用状态 0：离职  1：在职 默认为在职*/
        jobStatus: 1,
      },
      bindOptions: [
        {
          bindStatus: 1,
          label: "已绑定",
        },
        {
          bindStatus: 0,
          label: "未绑定",
        },
      ],
      enableOptions: [
        {
          enbaleStatus: 1,
          label: "已启用",
        },
        {
          enbaleStatus: 0,
          label: "已停用",
        },
      ],
      // 点位占数比对象
      pointRespon: {
        licenseOpen: 0, //占比分子
        point: 0, //占比分母
        mark: 2, //1：剩余日期大于30天  2：剩余日期大于0天小于30天，需提示  3：服务时间已过期
        expiredTime: "", //服务到期时间
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      tempDepartmentId: 0, //部门id中间变量
      tempDepartmentIdMax: 0, //最高级部门id中间变量
      tempDepartmentName: "", //部门名中间变量
      tempDepart: [], //部门列表用于部门搜索使用
      queryDepart: "", //部门搜索框查询条件

      //员工绑定-弹窗
      dialogVisibleBind: false, //绑定--弹窗
      departmentList: [], //院内部门
      informationList: [], //院内信息列表
      //员工弹窗-搜索
      searchObj: {
        empCodeOrName: "",
        dptCode: "",
        earId: "",
        dptId: "",
      },
      // 选中高亮
      selectRow: [],
      selectData: [],
      // 绑定-表格-指定行颜色
      tableChecked: null,
      currentSelectItem: {}, //当前选中的对象
      bumenName: "全部部门",
      jieState: true,
      firstState: 0,
    };
  },
  created() {
    this.getDepartmentListData(); //页面第一次进来的时候就加载最高级部门的数据
    // this.getDepartmentStaffData(this.tempDepartmentId, this.formInline);
    // 初始化
    this.getEmpBindList();
    this.getEmpDepartList();
    this.getLicensePoint();
  },
  watch: {
    selectData(data) {
      this.selectRow = [];
      if (data.length > 0) {
        data.forEach((item, index) => {
          this.selectRow.push(this.informationList.indexOf(item));
        });
      }
    },
    btnAuthority: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "员工管理") {
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("kbdjb") != -1) {
                // 可绑定、解绑
                this.kbdjb = true;
              } else {
                this.kbdjb = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  methods: {
    // 选择成员的确认回调
    clickSubmitTree(val) {
      this.staffTreeShow = false;
      console.log("al", val);
      if (val.currentMember.length > 0) {
        this.disablePrams.takeoverUserId = val.currentMember[0].userId;
        this.disEnable();
      }
    },
    // 关闭选择成员的弹框
    closeTree() {
      this.staffTreeShow = false;
    },
    // 启用账号
    enableAccount(userId) {
      this.$confirm("确认是否启用该账号的使用权限？", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        iconClass: "el-icon-warning",
        customClass: "delete-messege",
        center: true,
      })
        .then((res) => {
          userEnable(userId, localStorage.getItem("Authorization")).then(
            (res) => {
              if (res.error.code == 200) {
                this.$store.dispatch("tagsView/setTree1", []);
                this.$message.success("账号已启用!");
                this.getLicensePoint();
                this.getDepartmentStaffData(
                  this.tempDepartmentId,
                  this.tempDepartmentName,
                  this.formInline
                );
              }
            }
          );
        })
        .catch((action) => {
          // this.$message("取消删除");
        });
    },
    // 同步通讯录
    synchronizesContact() {
      this.isSynchronizes = true;
      syncWeStaffInformal(localStorage.getItem("Authorization"), true)
        .then((res) => {
          if (res.error.code == 200) {
            this.$message.success("已同步至最新的通讯录!");
            this.isSynchronizes = false;
          } else {
            this.$message.error("同步失败，请重试!");
            this.isSynchronizes = false;
          }
        })
        .catch((err) => {
          this.$message.error("同步失败，请重试!");
          this.isSynchronizes = false;
        });
    },
    // 启用账号数占比
    getLicensePoint() {
      getLicensePoint(localStorage.getItem("Authorization")).then((res) => {
        if (res.error.code == 200) {
          this.pointRespon = res.data;
        } else {
          this.$message.error("获取启用账号数占比失败，请刷新重试!");
        }
      });
    },
    // 停用点击事件
    disableAccount(row) {
      this.toBeReplaced = [];
      let obj = {
        name: row.name,
        userId: row.userId,
      };
      this.toBeReplaced.push(obj);
      this.isTransfer(row.userId, row.corpId);
    },
    // 继承许可账号是否超过30天
    isTransfer(userId, corpId) {
      isTransfer(userId, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            this.$confirm(
              "停用该账号之前，需选择其他成员继承该账号的使用权限",
              {
                distinguishCancelAndClose: true,
                closeOnClickModal: false,
                confirmButtonText: "去选择成员",
                cancelButtonText: "取消",
                type: "warning",
                iconClass: "el-icon-warning",
                customClass: "delete-messege",
                center: true,
              }
            )
              .then((res) => {
                this.disablePrams.corpId = corpId;
                this.disablePrams.handoverUserId = userId;
                // 选择成员
                this.staffTreeShow = true;
              })
              .catch((action) => {
                // this.$message("取消删除");
              });
          }
        })
        .catch((err) => {});
    },
    disEnable() {
      disEnable(this.disablePrams, localStorage.getItem("Authorization")).then(
        (res) => {
          if (res.error.code == 200) {
            this.$message.success("账号权限转接成功!");
            // 更新数据
            this.getDepartmentStaffData(
              this.tempDepartmentId,
              this.tempDepartmentName,
              this.formInline
            );
          }
        }
      );
    },
    // 员工绑定开始
    // 获取部门信息列表
    getEmpBindList() {
      getEmpBind(
        {
          ...this.searchObj,
          pageSize: this.diaPageParm.pageSize,
          page: this.diaPageParm.currentPage,
        },
        localStorage.getItem("Authorization")
      ).then((res) => {
        this.informationList = res.data ? res.data.result : [];
        this.diaPageParm.total = res.data.total;

        if (this.informationList.length !== 0) {
          this.informationList.forEach((item, index) => {
            if (item.empStatus == 1) {
              item.customState = 1;
            } else {
              item.customState = 0;
            }
          });
        }
      });
    },
    diaCallBack(parm) {
      this.diaPageParm.currentPage = parm.currentPage;
      this.diaPageParm.size = parm.pageSize;
      this.getEmpBindList();
    },
    // 获取院内部门
    getEmpDepartList() {
      getEmpDepart(localStorage.getItem("Authorization")).then((res) => {
        this.departmentList = res.data ? res.data.result : [];
        this.departmentList.unshift({
          dptCode: "",
          dptName: "全部部门",
          earId: "",
          id: 0,
        });
        if (this.departmentList.length !== 0) {
          this.departmentList.forEach((item, index) => {
            item.id = index;
          });
        }
      });
    },
    searchFn(row = false) {
      if (!!row || row == 0) {
        this.departmentList.forEach((item, index) => {
          if (row === index) {
            this.searchObj.dptCode = item.dptCode;
            this.searchObj.earId = item.earId;
            this.searchObj.dptId = item.dptId;
            this.bumenName = item.dptName;
          }
        });
      }
      this.diaPageParm.currentPage = 1;
      this.getEmpBindList();
    },
    // 选中筛选结果时候
    handleSelectionChange(row) {
      if (this.currentRowInfo.bindStatus == 1) {
        if (this.jieState && this.firstState != 0) {
          this.$message.warning("您已有绑定信息!");
        }
        this.firstState = 1;
        return;
      }
      if (!!!row) {
        return;
      }
      this.firstState = 1;
      this.jieState = true;
      this.tableChecked = row.id;
      this.informationList.forEach((item, index) => {
        // 如果没绑定清空上次选中的状态
        if (!!this.currentSelectItem) {
          if (item.id === this.currentSelectItem.id) {
            if (this.currentSelectItem.empStatus == 0) {
              item.customState = 0;
              item.departmentName = null;
              item.qwAccount = null;
              item.name = null;
              item.avatar = null;
              item.userId = null;
            } else {
              item.customState = 1;
            }
          }
        }
        if (row.id == item.id) {
          if (row.empStatus == 0) {
            item.departmentName = this.currentRowInfo.departmentName;
            item.qwAccount = this.currentRowInfo.qwAccount;
            item.name = this.currentRowInfo.name;
            item.avatar = this.currentRowInfo.avatar;
            item.userId = this.currentRowInfo.userId;
          }
        }
      });
      this.currentSelectItem = row;
      this.selectData = [row]; //高亮
    },
    // 多选高亮选中行
    rowClass({ row, rowIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "#ecf5ff" };
      }
      if (row.empStatus == 1) {
        return { color: "rgb(201, 205, 212)" };
      }
    },
    // 打开弹窗
    handleBind(row) {
      if (this.kbdjb) {
        this.currentRowInfo = row;
        this.dialogVisibleBind = true;
        setTimeout(() => {
          this.informationList.forEach((item, index) => {
            if (
              item.earId === row.earId &&
              item.empCode === row.empCode &&
              row.bindStatus == 1
            ) {
              this.selectData = [item]; //高亮
              this.$tableScrollMove("multipleTables", index);
            }
          });
        }, 200);
      }
    },
    // 关闭弹窗
    handleClose() {
      // 清空选中的信息
      this.dialogVisibleBind = false;
      if (this.informationList.length === 0) return;
      this.tableChecked = null;
      this.informationList.forEach((item, index) => {
        if (item.empStatus == 1) {
          item.customState = 1;
        } else {
          item.customState = 0;
          item.departmentName = "";
          item.qwAccount = "";
          item.name = "";
          item.avatar = "";
          item.userId = "";
        }
      });
      this.informationList = JSON.parse(JSON.stringify(this.informationList));

      this.selectData = [];
      this.currentSelectItem = {};
    },
    // 绑定员工
    hanldeBingFn(row, index) {
      if (!row.userId) {
        this.$message.error("请勾选要绑定的数据");
        return;
      }
      let objC = {
        userId: row.userId,
        earId: row.earId,
        empCode: row.empCode,
      };
      let msg = "将员工与院务系统的职员：" + row.name + "进行绑定";
      this.$confirm(msg, {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        iconClass: "el-icon-warning",
        customClass: "delete-messege",
        center: true,
      })
        .then((res) => {
          saveEmpBind(objC, localStorage.getItem("Authorization")).then(
            (res) => {
              if (res.error.code == 200) {
                this.$message.success("绑定成功");
                let obj = this.informationList[index];
                obj.empStatus = 1;
                this.currentRowInfo.bindStatus = 1;
                this.currentSelectItem
                  ? (this.currentSelectItem.empStatus = 1)
                  : "";
                this.firstState = 0;
                obj.customState = 1;
                this.$set(this.informationList, index, obj);
                this.informationList = JSON.parse(
                  JSON.stringify(this.informationList)
                ); //删除就不刷新
                this.getDepartmentListData();
              }
            }
          );
        })
        .catch((action) => {});
    },
    //员工解绑
    hanldeDelete(row, index) {
      this.jieState = false;
      let objC = {
        userId: row.userId,
        earId: row.earId,
        empCode: row.empCode,
      };
      let msg = "将员工与院务系统的职员：" + row.name + "进行解绑";
      this.$confirm(msg, {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "保存",
        cancelButtonText: "取消",
        type: "warning",
        iconClass: "el-icon-warning",
        customClass: "delete-messege",
        center: true,
      })
        .then((res) => {
          deleteEmpBind(objC, localStorage.getItem("Authorization")).then(
            (res) => {
              if (res.error.code == 200) {
                this.$message.success("解绑成功");
                this.informationList[index].customState = 0;
                this.informationList[index].empStatus = 0;
                this.currentSelectItem
                  ? (this.currentSelectItem.empStatus = 0)
                  : "";
                if (this.currentRowInfo.userId == row.userId) {
                  this.currentRowInfo.bindStatus = 0;
                }
                this.firstState = 0;

                this.informationList = JSON.parse(
                  JSON.stringify(this.informationList)
                );
                this.getDepartmentListData();
              }
            }
          );
        })
        .catch((action) => {});
    },
    /**
     * @description: 通过表格索引 定位表格的位置
     * @param {refName} table的ref值
     * @param {index} table的索引值
     * @return:
     * @author: ywj
     */
    $tableScrollMove(refName, index = 0) {
      if (!refName || !this.$refs[refName]) return; //不存在表格的ref vm 则返回
      let vmEl = this.$refs[refName].$el;
      if (!vmEl) return;
      //计算滚动条的位置
      const targetTop = vmEl
        .querySelectorAll(".el-table__body tr")
        [index].getBoundingClientRect().top;
      const containerTop = vmEl
        .querySelector(".el-table__body")
        .getBoundingClientRect().top;
      const scrollParent = vmEl.querySelector(".el-table__body-wrapper");
      scrollParent.scrollTop = targetTop - containerTop - 150;
    },
    // 员工绑定结束

    disableStatus(staffRoleList) {
      //判断 staffRoleList对象数组中的roleId是否等于0，返回值为true，则有roleId等于0
      var boolean = staffRoleList.some((item) => item.roleId == 0);
      return boolean;
    },
    disableStatusApp(staffRoleList) {
      var boolean = staffRoleList.some((item) => item.roleId == 0);
      return boolean;
    },
    // 启用状态改变响应事件
    selectStatus() {
      this.formInline.currentPage = 1;
      this.getDepartmentStaffData(
        this.tempDepartmentId,
        this.tempDepartmentName,
        this.formInline
      );
    },
    // 绑定状态改变响应事件
    selectBindStatus(value) {
      // this.loading = true;
      this.formInline.currentPage = 1;
      this.getDepartmentStaffData(
        this.tempDepartmentId,
        this.tempDepartmentName,
        this.formInline
      );
    },
    selectEnableStatus(value) {
      // this.loading = true;
      this.formInline.currentPage = 1;
      this.getDepartmentStaffData(
        this.tempDepartmentId,
        this.tempDepartmentName,
        this.formInline
      );
    },
    selectEnableAppStatus() {
      // this.loading = true;
      this.formInline.currentPage = 1;
      this.getDepartmentStaffData(
        this.tempDepartmentId,
        this.tempDepartmentName,
        this.formInline
      );
    },
    callBack(parm) {
      this.formInline.currentPage = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      // this.loading = true;
      this.getDepartmentStaffData(
        this.tempDepartmentId,
        this.tempDepartmentName,
        this.formInline
      );
    },
    onInputBlurNameMobile() {
      // this.loading = true;
      this.formInline.currentPage = 1;
      // this.formInline.pageSize = 10

      if (this.queryDepart != "" && this.queryDepart != undefined) {
        this.$refs.authTree.setCurrentKey(this.tempDepartmentId);
        this.getDepartmentStaffData(
          this.tempDepartmentId,
          this.tempDepartmentName,
          this.formInline
        );
      } else {
        this.$refs.authTree.setCurrentKey(this.tempDepartmentIdMax);
        this.tempDepartmentId = this.tempDepartmentIdMax;
        this.getDepartmentStaffData(
          this.tempDepartmentIdMax,
          this.tempDepartmentName,
          this.formInline
        );
      }
    },
    onInputBlurDepart() {
      var flag = false;
      var tempId = "";
      var tempName = "";
      this.tempDepart.forEach((item) => {
        if (item.departmentName == this.queryDepart) {
          flag = true;
          tempId = item.departmentId;
          tempName = item.departmentName;
        }
      });
      if (flag) {
        // this.loading = true;
        this.formInline.currentPage = 1;
        // this.formInline.pageSize = 10
        this.tempDepartmentId = tempId;
        this.$refs.authTree.setCurrentKey(tempId);
        this.getDepartmentStaffData(tempId, tempName, this.formInline);
      } else {
        this.queryDepart = "";
        // this.$message({
        //   showClose: true,
        //   message: "输入的部门名不完整或者不正确，请重新输入！",
        //   type: "warning",
        //   offset: 90,
        //   duration: 4000,
        // });
      }
    },
    openOrClose(index, row) {
      this.setStaffStatusData(row.userId, row.status, row);
    },
    openOrCloseApp(index, row) {
      this.setStaffAppStatusData(row.userId, row.appStatus, row);
    },
    handleCheckChange: function(data, checked) {},
    nodeClick(data, node, s) {
      // this.loading = true;
      this.tempDepartmentId = node.data.departmentId;
      this.tempDepartmentName = node.data.departmentName;
      this.formInline.currentPage = 1;
      // this.formInline.pageSize = 10
      this.formInline.queryStaff = "";
      this.queryDepart = "";
      this.getDepartmentStaffData(
        node.data.departmentId,
        node.data.departmentName,
        this.formInline
      );
    },
    getDepartmentListData() {
      getDepartmentList(localStorage.getItem("Authorization")).then((res) => {
        if (res.error.code == 200) {
          console.log("222");
          console.log(res.data);
          this.listData = res.data.resultDepartSort;
          this.$nextTick(() => {
            //等树结构渲染完成后设置节点高亮
            this.$refs.authTree.setCurrentKey(
              res.data.resultDepartSort[0].departmentId
            );
          });
          this.tempDepartmentId = res.data.resultDepartSort[0].departmentId;
          this.tempDepartmentIdMax = res.data.resultDepartSort[0].departmentId;
          this.tempDepartmentName = res.data.resultDepartSort[0].departmentName;
          this.tempDepart = res.data.resultDepart;
          this.getDepartmentStaffData(
            this.tempDepartmentId,
            this.tempDepartmentName,
            this.formInline
          );
        }
      });
    },

    getDepartmentStaffData(departmentId, departmentName, parameter) {
      getDepartmentStaff(
        departmentId,
        departmentName,
        parameter,
        localStorage.getItem("Authorization")
      ).then((res) => {
        if (res.error.code == 200) {
          this.staffData = res.data.result;
          // this.loading = false;
          this.pageparm.total = res.data.totals;
          this.pageparm.currentPage = this.formInline.currentPage;
          this.pageparm.pageSize = this.formInline.pageSize;
        }
      });
    },
    //设置后台的启用/停用
    setStaffStatusData(userId, status, row) {
      setStatffStatus(
        userId,
        status,
        localStorage.getItem("Authorization")
      ).then((res) => {
        if (res.error.code == 500) {
          this.$message({
            message: res.error.message,
            type: "warning",
          });
          row.status = 0;
        }
        if (res.error.code == 403) {
          this.$message({
            message: res.error.message,
            type: "error",
            offset: 350,
            duration: 4000,
            showClose: true,
          });
          row.status = 0;
        }
      });
    },
    setStaffAppStatusData(userId, appStatus, row) {
      setStaffAppStatus(
        userId,
        appStatus,
        localStorage.getItem("Authorization")
      ).then((res) => {
        if (res.error.code == 500) {
          this.$message({
            message: res.error.message,
            type: "warning",
          });
          row.appStatus = 0;
        }
        if (res.error.code == 403) {
          this.$message({
            message: res.error.message,
            type: "error",
            offset: 350,
            duration: 4000,
            showClose: true,
          });
          row.appStatus = 0;
        }
      });
    },

    //设置table距离浏览器底部的高度
    controlHeight() {
      this.$nextTick(function() {
        this.tableHeight =
          window.innerHeight - this.$refs.singleTable.$el.offsetTop - 200;
        // 监听窗口大小变化
        let self = this;
        window.onresize = function() {
          self.tableHeight =
            window.innerHeight - self.$refs.singleTable.$el.offsetTop - 190;
        };
      });
    },

    /** 显示离职员工状态改变触发 */
    jobStatusChange() {
      this.getDepartmentStaffData(
        this.tempDepartmentId,
        this.tempDepartmentName,
        this.formInline
      );
    },
  },
  mounted() {
    this.controlHeight();
  },
};
</script>
<style scoped lang="scss">
.auth-container {
  height: 100%;
  width: 100%;
  display: flex;
  object-fit: fill;
}
.staff-title {
  display: flex;
  flex-direction: column;
  .title-name {
    font-size: 13px;
    font-weight: bold;
    margin-bottom: 15px;
  }
}
.auth-aside {
  flex: 1;
  width: 280px !important;
  padding: 0px 10px 0 0;
  object-fit: fill;
  overflow-x: hidden;
}
// /deep/.el-tree-node__content {
//   height: auto;
// }
.auth-main {
  padding: 0 0 0 10px !important;
  display: flex;
  flex-direction: column;
  .tip-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .num-wrap {
      color: #666666;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
    }
    .time-out-wrap {
      color: #8c8c8c;
      font-weight: 300;
      font-size: 12px;
      line-height: 22px;
    }
  }
}
.main-staff1 {
  height: 100%;
  // min-width: 1160px;
  // 自定义节点
  .comp-tr-node {
    // label
    flex: 1;
    display: flex;
    width: 0;
    .comp-tr-node--name {
      font-size: 14px;
      padding: 8px 2px 8px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .enable {
    color: #2684ff;
    cursor: pointer;
  }
  .unenable {
    color: #ff4150;
    cursor: pointer;
  }
}
.dialog-comster {
  /deep/ .el-dialog__body {
    margin: 0;
    padding: 20px 20px 10px;
  }
  .staff1-search {
    margin-bottom: 5px;
  }
}
/deep/.el-table th > .cell {
  padding-left: 20px;
  padding-right: 20px;
}
/deep/.el-table .cell {
  padding-left: 20px;
  padding-right: 20px;
}
.icon-style {
  margin-left: 4px;
}
</style>
